import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API } from 'aws-amplify';
import {taxRateBefore20191001, taxRateAfter20191001, taxChangeBorder} from './Settings';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutline';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { withSnackbar } from 'notistack';
import {v4 as uuidv4} from 'uuid/v4';
import moment from 'moment';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 0,
    width: 300,
  },
  menuButton:{
    margin:5
  },
  longTableCell:{
    color: "#676767",
    maxWidth: 400,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
});

const initialState = {
  categorizedMenuItems: [],
  menuCategorys: [],
  reservations: [],
  reservation: {},
  orderDialogOpen: false,
  scroll: "paper",
  inputMenuItemName: "",
  inputAmount: "",
  inputPrice: "",
  inputTaxType: "",
  inputOrders: [],
  taxRate: moment().startOf('days').isAfter(moment(taxChangeBorder)) ? taxRateAfter20191001 : taxRateBefore20191001
};

class InputOrder extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  compareDate = (a, b) => {
    const dateA = a.date;
    const dateB = b.date;

    let comparison = 0;
    if (dateA > dateB) {
      comparison = 1;
    } else if (dateA < dateB) {
      comparison = -1;
    }
    return comparison;
  }

  comparePriority = (a, b) => {
    const priorityA = a.priority;
    const priorityB = b.priority;

    let comparison = 0;
    if (priorityA > priorityB) {
      comparison = 1;
    } else if (priorityA < priorityB) {
      comparison = -1;
    }
    return comparison;
  }

  componentWillMount(){
    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-active-checked-in-reservations'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log(response);
      response.reservations.sort(this.compareDate);
      this.setState({
        reservations : response.reservations,
      },() => {
        for(let i in this.state.reservations){
          this.setState({
            [this.state.reservations[i].reservation_id + "S1"]: this.state.reservations[i].status === "active_reserved_todo" ? "no" : "yes",
            [this.state.reservations[i].reservation_id + "C2"]: this.state.reservations[i].information_status === "no_need" ? "yes" : "no",
            [this.state.reservations[i].reservation_id + "S2"]: this.state.reservations[i].information_status === "done" ? "yes" : "no",
          })
        }
      });
    }).catch(error => {
      console.log(error);
    })

    path = '/menu-categorys'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log("response: ",response);
      response.menuCategorys.sort(this.comparePriority);
      this.setState({
        menuCategorys: response.menuCategorys
      },() => {
        path = '/menu-items'; //replace this with the path you have configured on your API

        API.get(apiName, path).then(response => {
          console.log("response: ",response);

          this.setState({
            menuItems: response.menuItems
          })

          let categorizedMenuItems = [];

          this.state.menuCategorys.map(n => {
            let item = {};

            let category = n.name;
            item.category = category;

            let categoryItems = response.menuItems.filter(function(item, index){
              if (item.menu_category_id === n.menu_category_id) return true;
              return false;
            });
            categoryItems.sort(this.comparePriority);
            item.categoryItems = categoryItems;

            categorizedMenuItems.push(item);

            return true;
          })

          this.setState({
            categorizedMenuItems: categorizedMenuItems
          },() => {
            console.log("this.state: ", this.state);
          })

        }).catch(error => {
          console.log(error);
        })
      })
    }).catch(error => {
      console.log(error);
    })
  }

  handleChange = (event, key) => {
    console.log("key: ", key);
    console.log("event.target.value: ", event.target.value);
    this.setState({
      [key] : event.target.value
    },() => {
      console.log("this.state: ", this.state);
    });

  }

  selectReservation = (reservation, scroll, name) => {
    this.setState({
      [name]: true,
      scroll: scroll,
      reservation: reservation,
    },() => {
      console.log(this.state);

      let apiName = 'MyAPIGatewayAPI';
      let path = '/search-orders';

      let body = {
        ordersId: this.state.reservation.ordersId,
      };

      let myInit = {
        body: body, // replace this with attributes you need
      }

      API.post(apiName, path, myInit).then(response => {
        console.log(response);

        let inputOrders = [];

        if(response.orders){
          inputOrders = response.orders.orders;
        }
        this.setState({
          inputOrders : inputOrders,
        });
      }).catch(error => {
        console.log(error);
      })
    });
  }

  handleCloseDialog = name => {
    this.setState({
      [name]: false,
      inputMenuItemName: "",
      inputAmount: "",
      inputPrice: "",
      inputTaxType: "",
    });
  }

  handleChangeAmount = (num, menuItemId) => {
    console.log("num: ", num);
    console.log("menuItemId: ", menuItemId);

    let menuItem = this.state.inputOrders.find((menuItem) => {
        return (menuItem.menuItemId === menuItemId);
    });

    console.log(menuItem)

    let inputOrderItemBefore = this.state.inputOrders.find((inputOrderItem) => {
        return (inputOrderItem.menuItemId === menuItemId);
    });

    let inputOrdersAfter = this.state.inputOrders;
    let inputOrdersAfterNum;

    inputOrdersAfter.some(function(inputOrderItem, i){
      if (inputOrderItem.menuItemId === menuItemId){
        inputOrdersAfterNum = i;
        inputOrdersAfter.splice(i,1);
        return true;
      }
      return false;
    });

    let inputOrderItemAfter ={
      menuItemId: menuItem.menuItemId,
      name: menuItem.name,
      price: menuItem.price,
      taxType: menuItem.taxType
    }

    let amount = Number(inputOrderItemBefore.amount) + num;

    if(amount > 0){
      inputOrderItemAfter.amount = amount.toString();
      inputOrdersAfter.splice(inputOrdersAfterNum , 0 , inputOrderItemAfter);
    }

    this.setState({
      inputOrders: inputOrdersAfter,
    })
  }

  handleAddMenuItem = (menuItemId) => {
    let menuItem = this.state.menuItems.find((menuItem) => {
        return (menuItem.menu_item_id === menuItemId);
    });

    console.log("menuItem: ", menuItem)

    let inputOrderItemBefore = this.state.inputOrders.find((inputOrderItem) => {
        return (inputOrderItem.menuItemId === menuItemId);
    });

    let inputOrdersAfter = this.state.inputOrders;
    let inputOrdersAfterNum;

    inputOrdersAfter.some(function(inputOrderItem, i){
      if (inputOrderItem.menuItemId === menuItemId){
        inputOrdersAfterNum = i;
        inputOrdersAfter.splice(i,1);
        return true;
      }
      return false;
    });

    let inputOrderItemAfter ={
      menuItemId: menuItem.menu_item_id,
      name: menuItem.name,
      price: menuItem.price,
      taxType: "税込"
    }

    if(inputOrderItemBefore){
      inputOrderItemAfter.amount = (Number(inputOrderItemBefore.amount) + 1).toString();
      inputOrdersAfter.splice(inputOrdersAfterNum , 0 , inputOrderItemAfter);
    }else{
      inputOrderItemAfter.amount = "1";
      inputOrdersAfter.push(inputOrderItemAfter);
    }

    this.setState({
      inputOrders: inputOrdersAfter,
    })
  }

  handleAddOptionalMenuItem = () => {

    let optionalMenuItem = {
      menuItemId : "m-" + uuidv4(),
      name: this.state.inputMenuItemName,
      price: this.state.inputPrice,
      amount: this.state.inputAmount,
      taxType: this.state.inputTaxType,
    }

    let inputOrdersAfter = this.state.inputOrders;
    inputOrdersAfter.push(optionalMenuItem);

    this.setState({
      inputOrders: inputOrdersAfter,
      inputMenuItemName: "",
      inputPrice: "",
      inputAmount: "",
      inputTaxType: "",
    })

  }

  handleUpdateOrders = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/update-orders'; //replace this with the path you have configured on your API

    let body = {
      orders_id: this.state.reservation.ordersId,
      orders: this.state.inputOrders
    };

    let myInit = {
      body: body, // replace this with attributes you need
    }

    const { enqueueSnackbar } = this.props;

    API.post(apiName, path, myInit).then(response => {
      console.log(response)
      enqueueSnackbar(response.message, {variant : 'success'});
      this.setState({
        orderDialogOpen: false
      })
    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  calculatePrice = () => {
    let priceOuterTax = 0;

    this.state.inputOrders.map(n => {
      if(n.taxType === "税別"){
        priceOuterTax += (Number(n.amount) * Number(n.price));
        console.log("priceOuterTax: ", priceOuterTax)
      }
      return true;
    })

    let priceOuterTaxTotal = priceOuterTax * (1 + Number(this.state.taxRate));

    let priceInnerTax = 0;

    this.state.inputOrders.map(n => {
      if(n.taxType === "税込"){
        priceInnerTax += (Number(n.amount) * Number(n.price));
        console.log("priceInnerTax: ", priceInnerTax)
      }
      return true;
    })

    let price = Math.floor(priceOuterTaxTotal + priceInnerTax);

    return price;
  }

  render() {
    const {classes} = this.props
    const {
      categorizedMenuItems,
      reservations,
      reservation,
      orderDialogOpen,
      scroll,
      inputMenuItemName,
      inputAmount,
      inputPrice,
      inputTaxType,
      inputOrders,
    } = this.state;

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              オーダー入力
            </Typography>
          </Grid>
          <Grid item>

            <Typography variant="h6" gutterBottom　style={{display: reservations.length === 0 ? "" : "none"}}>
              表示する予約がありません
            </Typography>


            <Paper className={classes.root} elevation={1} style={{display: reservations.length === 0 ? "none" : ""}}>
              <Typography variant="h5" gutterBottom>
                チェックイン済み予約
              </Typography>
              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="center">宿泊開始日</TableCell>
                    <TableCell style={{color: "#676767"}} align="center">お部屋</TableCell>
                    <TableCell style={{color: "#676767"}} align="center">お名前</TableCell>
                    <TableCell style={{color: "#676767"}} align="center">オーダー入力</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reservations.map(n =>
                    {
                      let rooms = "";
                      for(let i in n.input_rooms){
                        rooms = rooms + n.input_rooms[i]
                        if(i !== n.input_rooms.length - 1){
                          rooms = rooms + " "
                        }
                      }

                      let inputReservation ={
                        reservationId: n.reservation_id,
                        lastName: n.last_name,
                        firstName: n.first_name,
                        ordersId: n.orders_id
                      }

                      return (
                        <TableRow key={n.reservation_id}>
                          <TableCell align="center">{n.date}</TableCell>
                          <TableCell align="center">{rooms}</TableCell>
                          <TableCell align="center">{n.last_name} {n.first_name} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div></TableCell>
                          <TableCell align="center">
                          <Button onClick={() => this.selectReservation(inputReservation, 'paper', 'orderDialogOpen')} variant="contained" color="default" className={classes.button} style={{marginTop:10, marginBottom:10}}>
                            選択
                          </Button>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </Grid>
        <Dialog
          open={orderDialogOpen}
          onClose={() => this.handleCloseDialog('orderDialogOpen')}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">オーダー入力</DialogTitle>
          <DialogContent>
            {categorizedMenuItems.map(n => {
              return(
                <Fragment key={n.category}>
                  <Typography  key={n.category} variant="subtitle1" style={{marginTop:20}}>
                    {n.category}
                  </Typography>
                  {n.categoryItems.map(m => {
                    return (
                      <Button key={m.menu_item_id} onClick={() => this.handleAddMenuItem(m.menu_item_id)} size="small" variant="contained"  color="default" className={classes.menuButton}>
                        {m.name_short}
                      </Button>
                    )
                  })}
                </Fragment>
              )
            })}
            <div style={{marginBottom: 25}}>
              <Typography variant="subtitle1" style={{marginTop:20}}>
                任意入力
              </Typography>
              <ValidatorForm
                ref="form"
                onSubmit={() => this.handleAddOptionalMenuItem()}
                onError={
                  errors => {
                    console.log(errors);
                    const { enqueueSnackbar } = this.props;
                    enqueueSnackbar('任意の項目が不正です', {variant : 'warning'});
                  }
                }
              >
                <TextValidator
                  className={classes.textField}
                  name="inputMenuItemName"
                  label="品目名"
                  value={inputMenuItemName}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputMenuItemName')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                />
                <TextValidator
                  className={classes.textField}
                  name="inputPrice"
                  label="単価"
                  value={inputPrice}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputPrice')}
                  required={true}
                  type="number"
                  min="0"
                  validators={['required', 'isNumber', 'minNumber:0']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 150}}
                />
                <TextValidator
                  className={classes.textField}
                  name="amount"
                  label="数量"
                  value={inputAmount}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'inputAmount')}
                  required={true}
                  type="number"
                  min="0"
                  validators={['required', 'isNumber', 'minNumber:0']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                  style={{width: 80}}
                />
                <FormControl required={true} className={classes.formControl} style={{width:120, marginLeft:10}}>
                  <InputLabel htmlFor="customer-type-helper">消費税区分</InputLabel>
                  <Select
                    value={inputTaxType}
                    onChange={(e) => this.handleChange(e,'inputTaxType')}
                    input={<Input name="type" id="customer-type-helper" />}
                  >
                    <MenuItem value={'税別'}>税別</MenuItem>
                    <MenuItem value={'税込'}>税込</MenuItem>
                  </Select>
                </FormControl>
                <Button type="submit" variant="contained" color="default" className={classes.button} style={{marginLeft:25, marginTop:10}}>
                  追加
                </Button>
              </ValidatorForm>
            </div>



            <Paper className={classes.root} elevation={4} style={{marginTop: 50}}>
              <Typography variant="h5" gutterBottom>
                {reservation.lastName} {reservation.firstName} <div style={{marginLeft: 10, fontSize:"0.8em", display: "inline"}}>様</div>
              </Typography>


              <Table className={classes.table} style={{marginTop: 20}}>
                <TableHead style={{backgroundColor:"#f3f3f3"}}>
                  <TableRow>
                    <TableCell className={classes.longTableCell} align="center">品名</TableCell>
                    <TableCell style={{color: "#676767"}} align="center">単価</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none">数量</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none">消費税区分</TableCell>
                    <TableCell style={{color: "#676767"}} align="center">小計</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {inputOrders.map(n => {
                    return(
                      <TableRow key={n.menuItemId}>
                        <TableCell className={classes.longTableCell} align="center">{n.name}</TableCell>
                        <TableCell style={{color: "#676767"}} align="center">￥ {Number(n.price).toLocaleString()}</TableCell>
                        <TableCell style={{color: "#676767"}} align="center" padding="none">{n.amount}</TableCell>
                        <TableCell style={{color: "#676767"}} align="center" padding="none">
                          <IconButton onClick={() => this.handleChangeAmount(1, n.menuItemId)} size="small" color="default" aria-label="Add" className={classes.margin}>
                            <AddIcon />
                          </IconButton>
                          <IconButton onClick={() => this.handleChangeAmount(-1, n.menuItemId)} size="small" color="default" aria-label="Remove" className={classes.margin}>
                            <RemoveIcon />
                          </IconButton>
                        </TableCell>
                        <TableCell style={{color: "#676767"}} align="center" padding="none">{n.taxType}</TableCell>
                        <TableCell style={{color: "#676767"}} align="center">￥ {(Number(n.price) * Number(n.amount)).toLocaleString()}</TableCell>
                      </TableRow>
                    )
                  })
                  }
                  <TableRow>
                    <TableCell className={classes.longTableCell} align="center"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center"></TableCell>
                  </TableRow>
                  <TableRow style={{backgroundColor:"#d0d0d0"}}>
                    <TableCell className={classes.longTableCell} align="center">オーダー小計(税込)</TableCell>
                    <TableCell style={{color: "#676767"}} align="center"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="none"></TableCell>
                    <TableCell style={{color: "#676767"}} align="center">￥ {this.calculatePrice().toLocaleString()}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Button size="small" variant="contained"  color="primary" onClick={this.handleUpdateOrders} className={classes.menuButton} style={{marginLeft: "92%", marginTop:50}}>
                更新
              </Button>
            </Paper>

          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog('orderDialogOpen')} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

InputOrder.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(InputOrder)));
